export function unknownToDisplayString(value: unknown, fallback = "-"): string {
    if (value == null || value === "") {
        return fallback;
    }
    if (typeof value === "string") {
        return value;
    }
    if (typeof value === "number" || typeof value === "boolean") {
        return String(value);
    }
    if (typeof value === "bigint") {
        return value.toString();
    }
    return fallback;
}
